import { render, staticRenderFns } from "./UsersOverviewPage.vue?vue&type=template&id=8c987000"
import script from "./UsersOverviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersOverviewPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports